import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {APP_INITIALIZER, NgModule} from '@angular/core';
import { FormsModule } from "@angular/forms";
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { ComponentsModule } from './components/components.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AuthModule, LogLevel, OidcConfigService} from 'angular-auth-oidc-client';
import { EditorModule } from '@progress/kendo-angular-editor';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {DemoMaterialModule} from "./shared/material-module";
import {NotFoundComponent} from "./NotFound/notFound.component";
import {APP_BASE_HREF} from "@angular/common";
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

// If the project won't run: export NODE_OPTIONS=--openssl-legacy-provider



export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

export function configureAuth(oidcConfigService: OidcConfigService) {
  return () =>
    oidcConfigService.withConfig({
      clientId: 'ab2882e9-ecad-4518-8db3-bb0b34e8779b',
      stsServer: 'https://mac.medis.land',
      responseType: 'code',
      redirectUrl: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      scope: 'openid profile offline_access apiService_fe80b46f-7b4b-4a15-8029-270b806cfc33',
      silentRenew: true,
      useRefreshToken: true,
      silentRenewUrl: `${window.location.origin}/silent-renew.html`,
      renewTimeBeforeTokenExpiresInSeconds: 10,
      //logLevel: LogLevel.Debug,
    });
}

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    DemoMaterialModule,
    FontAwesomeModule,
    AppRoutingModule,
    AuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot(),
    EditorModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      scope: '/',
      registrationStrategy: 'registerImmediately'
    }),
  ],
  declarations: [AppComponent, AdminLayoutComponent, NotFoundComponent,],
  providers: [
    OidcConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureAuth,
      deps: [OidcConfigService],
      multi: true,
    }, {provide: APP_BASE_HREF, useValue: '/'}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
